import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiLoteActualizar } from '../../api/apiLoteActualizar'

import {
  loteActualizarComposeService,
  loteActualizarToApiCompose,
} from '../../services/loteActualizarComposeService'
import { LoteActualizarValidationSchema } from '../../validator/loteActualizar.validator'
import LoteForm from '../LoteForm'
import {
  LOTE_INITIAL_VALUES,
  LoteInputProps,
  LoteProps,
} from '../../../../interfaces/lote.ts'
import { actionLoteForm } from '../../interfaces'

interface OwnProps {
  keepMounted: boolean
  open: boolean
  lote: LoteProps
  onClose: (values?: LoteProps) => void
}

type Props = OwnProps

/**
 * @description Dialogo para actualizar un lote
 * @param props
 * @constructor
 */
const LoteActualizarDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, lote, ...other } = props
  //   console.log(lote, 'abierto');

  const form = useForm<LoteInputProps>({
    defaultValues: {
      ...LOTE_INITIAL_VALUES,
    },
    resolver: yupResolver<any, any, any>(LoteActualizarValidationSchema),
  })
  const confirm = useConfirm()

  /**
   * @description Guardamos los cambios en los lotes
   * @param values
   */
  const onSubmit: SubmitHandler<LoteInputProps> = async (values) => {
    try {
      const apiInput = loteActualizarToApiCompose(values)
      const { confirmed } = await confirm()
      if (!confirmed) return
      swalLoading()
      const resp = await apiLoteActualizar(lote._id, apiInput).catch((e) => {
        swalException(e)
      })
      if (resp) {
        notSuccess('Actualización exitosa')
        onClose(resp)
        swalClose()
      } else {
        console.log('error')
        // swalClose()
      }
    } catch (error) {
      if (error instanceof Error) {
        notError(`Error en las fechas: ${error.message}`)
      } else {
        notError('Error desconocido al procesar las fechas')
      }
    }
  }

  const onError = (error: any, e: any) => {
    console.error('Error:', error, e)
  }
  useEffect(() => {
    if (lote && open) {
      form.reset(loteActualizarComposeService(lote))
    }
  }, [open])
  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { maxHeight: '80vh' } }}
      maxWidth="sm"
      fullWidth
      open={open}
      {...other}
    >
      <DialogTitle>Editar Lote</DialogTitle>

      <DialogContent dividers>
        <LoteForm form={form} action={actionLoteForm.UPDATE} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus color={'error'} size={'small'} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          sx={{ mr: 2 }}
          variant={'contained'}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default LoteActualizarDialog
